module.exports = __webpack_public_path__ + "img/pay.fb1b8f04.svg";